import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default props => {
  return (
    <Container
      fluid
      className="text-center"
      style={{
        backgroundColor: "#444",
        minHeight: "5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Row>
        <Col>
          <span style={{ color: "white" }}> © 2021-2022 </span>
        </Col>
      </Row>
    </Container>
  );
};
